import * as React from "react";
import {
  Button,
  useUpdateMany,
  useRefresh,
  useNotify,
  useUnselectAll,
} from "react-admin";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import { api_url } from "../api";
import axios from "axios";

const UserGroupChangeButton = ({ selectedIds, isSelect }) => {
  const handle = async () => {
    try {
      const promises = selectedIds.map((id) =>
        axios.patch(
          `${api_url}/user-groups/${id}`,
          { groupId: Number(isSelect) },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
      );
      await Promise.all(promises);
      window.location.reload();
    } catch {
      alert("다시 시도해 주세요!");
    }
  };

  return (
    <Button label="선택 인원 그룹 변경" onClick={handle}>
      <CompareArrowsIcon />
    </Button>
  );
};

export default UserGroupChangeButton;
